import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Text from '../shared/Text';

import { breakpoints, flexCenter, palette } from '../../constants/styles';

import CTAButton from '../shared/CTAButton';

const Container = styled.div`
  margin-top: 1em;
  ${flexCenter}
  flex-direction: column;
  ${({ styles }) => styles}
`;

const StyledSecondaryValuePropCTA = css`
  background-color: white;
  color: ${palette.primaryColor};
  border: 1px solid ${palette.primaryColor};
  margin-right: 5px;

  &:hover {
    background-color: rgba(2, 39, 89, 0.05);
  }
`;

const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const GetStarted = ({
  buttonStyles,
  styles,
  showFree,
  to,
  title,
  incentiveColor,
  customMessage,
  event,
  showExample,
}) => (
  <Container styles={styles}>
    <StyledButtonsContainer>
      {showExample && (
        <CTAButton
          internalLink="/plan/res/7314/preview"
          buttonText="Ver ejemplo"
          buttonStyles={StyledSecondaryValuePropCTA}
        />
      )}
      <CTAButton buttonText={title} buttonStyles={buttonStyles} externalLink={to} event={event} />
    </StyledButtonsContainer>
    {showFree && (
      <Text
        type="successMessage"
        styles={css`
          color: ${incentiveColor};
        `}
        medium
      >
        Es gratis... Sí, enserio
      </Text>
    )}
    {customMessage && (
      <Text
        type="successMessage"
        styles={css`
          color: ${incentiveColor};
        `}
        medium
      >
        {customMessage}
      </Text>
    )}
  </Container>
);

GetStarted.propTypes = {
  buttonStyles: PropTypes.array,
  styles: PropTypes.array,
  showFree: PropTypes.bool,
  to: PropTypes.string,
  title: PropTypes.string,
};

GetStarted.defaultProps = {
  buttonStyles: [],
  styles: [],
  showFree: false,
  to: '/router',
  title: 'Comenzar',
};

export default GetStarted;
